import { api } from 'api';
import { requestErrorAction } from 'common/utils/requestErrorHandling';
import { PaginatedResponse, PaginationParams } from '../types';
import { Bet } from './actions';

// #region Bet
export interface BetsParams extends PaginationParams {
  start_date?: string;
  end_date?: string;
  system?: string;
  username?: string | string[];
  bettor?: string;
  original_bookie?: string;
  original_username?: string;
  sport?: string;
  event?: string;
}

export const requestBets = async (params?: BetsParams, csv?: boolean) =>
  await api.get<PaginatedResponse<Bet>>('/bet/', {
    params,
    headers: { Accept: csv ? 'text/csv' : 'application/json' },
  });

export const doGetBets = (params?: BetsParams) => async (dispatch) => {
  dispatch({ type: 'bets/started' });

  try {
    const response = await requestBets(params);

    dispatch({
      type: 'bets/finished',
      bets: response.data.results,
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
    });
  } catch (e) {
    dispatch(
      requestErrorAction({ type: 'bets/finished' }, e, `Failed to get bets.`)
    );
  }
};
// #endregion
